import { GraphQLClient } from 'graphql-request';
import format from 'date-fns/format';
import { vessels } from './data/vessels';
import { portNamesWithShy } from './data/portNameCorrection';

const api = {
  client: new GraphQLClient(process.env.REACT_APP_APIURL, {
    headers: {}
  }),
  getVoyages: function(dateFrom, dateTo, pointFrom, pointTo, status) {
    const variables = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      pointFrom: pointFrom,
      pointTo: pointTo,
      status: status,
      hasDateRange: !!dateFrom || !!dateTo
    };
    const query = `
    query VoyageList($status: String, $dateFrom: String, $dateTo: String, $hasDateRange: Boolean!) {
      currentVoyages: voyages(status: "CURRENT") @skip(if: $hasDateRange) {
        ...voyageData
      }
      outstandingVoyages: voyages(status: "OUTSTANDING") @skip(if: $hasDateRange) {
        ...voyageData
      }
      rangedVoyages: voyages(status: $status, dateFrom: $dateFrom, dateTo: $dateTo) @include(if: $hasDateRange) {
        ...voyageData
      }
    }
    fragment voyageData on Voyage {
      Reference
      LastChanged
      Status
      Start
      End
      EstimatedTimeOfDeparture
      ServiceArea {
        Description
      }
      Visits {
        VoyageReference
        VisitNumber
        ETADate
        ETDDate
        CutoffDate
        ATADate
        ATDDate
        OriginalETADate
        OriginalETDDate
        PortActivity
        Pool {
          Name
          Port {
            LocalName,
            PortCode,
            TimeZone,
            TimeZoneDiff
          }
        }
      }
      Vessel {
        Reference
        Name
        PortRegistry
      }
    }`;
    return api.client.request(query, variables);
  }
};
const date = {
  formatDate: function(date, formatString) {
    return format(date, 'DD/MM/YYYY');
  },
  getDate: function(date) {
    let dateObj = new Date();
    if (!!date && date.constructor === Date) {
      dateObj = date;
    } else if (date) {
      dateObj = new Date(date);
    }
    return dateObj;
  },
  roundToHour: function(date) {
    const p = 60 * 60 * 1000; // milliseconds in an hour
    return new Date(Math.round(date.getTime() / p) * p);
  }
};
const getVesselImage = function(reference) {
  const imageFolder = '/vessels/';
  const defaultReference = 'DEFAULT';
  if (vessels[reference] && vessels[reference].image) {
    return imageFolder + vessels[reference].image;
  } else if (vessels[defaultReference] && vessels[defaultReference].image) {
    return imageFolder + vessels[defaultReference].image;
  } else {
    return '';
  }
};
const sortVoyagesByETDDate = function(a, b) {
  try {
    if (a.visits[0].ETADate < b.visits[0].ETADate) {
      return -1;
    }
    if (a.visits[0].ETADate > b.visits[0].ETADate) {
      return 1;
    }
    return 0;
  } catch (e) {
    return 0;
  }
};

const getPortNameWithShy = function(portName) {
  return portNamesWithShy.get(portName);
};

const isEmpty = function(array) {
  if (!Array.isArray(array) || !array.length) {
    // array does not exist, is not an array, or is empty
    return true;
  }

  return false;
};

const isNumeric = function(val) {
  return Number(parseFloat(val)) === val;
};

const isString = function(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};

const sortVoyages = function(a, b) {
  // Raða skipunum í þessa röð: Arnarfell, Helgafell, Bláfell, Skálafell, Skaftafell.
  const VESSEL_ORDER = ['ARN', 'HEG', 'BLA', 'SKA', 'SKF', 'HOF'];

  if (!a || !a.vessel || !a.vessel.reference || !b || !b.vessel || !b.vessel.reference) {
    return 0;
  }

  return VESSEL_ORDER.indexOf(a.vessel.reference) - VESSEL_ORDER.indexOf(b.vessel.reference);
};

const compareVoyagesByReferenceNumber = function(a, b) {
  if (a.reference < b.reference) {
    return -1;
  }
  if (a.reference > b.reference) {
    return 1;
  }
  // a must be equal to b
  return 0;
};

const isHostSubDomain = function(url) {
  // Remove www. from the beginning of the url
  url = url.replace(new RegExp(/^www\./i), "");
  // Remove url extensions '.??.??' OR '.???.??' e.g. '.CO.UK', '.COM.AU'
  if (url.match(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i))) {
    url = url.replace(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i), "");
    // Removes url extensions '.??' or '.???' or '.????' e.g. '.US', '.COM', '.INFO'
  } else if (url.match(new RegExp(/\.[a-z]{2,4}$/i))) {
    url = url.replace(new RegExp(/\.[a-z]{2,4}$/i), "");
  }
  return (url.match(new RegExp(/\./g))) ? true : false;
}

export {
  api,
  date,
  getVesselImage,
  sortVoyagesByETDDate,
  getPortNameWithShy,
  isEmpty,
  isString,
  isNumeric,
  sortVoyages,
  compareVoyagesByReferenceNumber,
  isHostSubDomain
};
export default {
  api: api,
  date: date,
  getVesselImage: getVesselImage,
  sortVoyagesByETDDate: sortVoyagesByETDDate,
  getPortNameWithShy: getPortNameWithShy,
  isEmpty: isEmpty,
  isString,
  isNumeric,
  sortVoyages,
  compareVoyagesByReferenceNumber,
  isHostSubDomain
};



// WEBPACK FOOTER //
// ./src/utils.js